import React from 'react';
import { Button, Grid, TextField, Typography, Paper } from '@mui/material';
import FormContainer from 'containers/FormContainer';
import ValidatePassword from 'components/ValidatePassword';
import IntlMessages from 'lngProvider/IntlMessages';
import * as Yup from 'yup';
import { styled } from '@mui/material/styles';
import { spacing } from 'styles/Common';
import { getPaperStyleObject } from 'styles/Paper';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root,
            "& .MuiInputLabel-shrink": {
                background: theme.palette.background.default
            },
            '& .MuiInputBase-input': {
                height: 30,
                padding: 4
            },
            '& .title-container': {
                marginBottom: spacing[1]
            }
        };
    });

const ResetPasswordWeb = (props) => {
    const validationSchema = Yup.object().shape({
        newPassword: Yup.string()
            .required(true)
            .min(8, true)
            .matches(
                process.env.REACT_APP_PASSWORD_REGEX,
                true),
        confirmNewPassword: Yup.string()
            .required(true)
            .oneOf([Yup.ref('newPassword')], true)
    });

    const { data, onSubmit, loginConfig } = props;

    return (
        <StyledPaper>
            <FormContainer
                initialValues={data || this.defaultState}
                validationSchema={validationSchema}
                onSubmit={onSubmit}>

                {props => {
                    const {
                        values,
                        errors,
                        touched,
                        isSubmitting,
                        handleChange,
                        handleBlur
                    } = props;

                    return (

                        <div>

                            <Grid container spacing={4} className="title-container">
                                <Grid item xs={12}>
                                    <Typography variant="h4"><IntlMessages id={loginConfig.resetPasswordTitle} /></Typography>
                                </Grid>
                                {values.showError === false ?
                                    <Grid item xs={12}>
                                        <Typography variant="h4"><IntlMessages id={loginConfig.resetPasswordSubTitle} /></Typography>
                                    </Grid>
                                    : ''}
                            </Grid>

                            {values.showError === false
                                ?
                                <Grid container spacing={4}>

                                    <Grid item xs={12}>

                                        <TextField
                                            label={<IntlMessages id="resetPassword.password" />}
                                            value={values.newPassword}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.newPassword && touched.newPassword}
                                            FormHelperTextProps={{ component: 'div', margin: 'dense' }}
                                            helperText={errors.newPassword ? <ValidatePassword data={values} /> : touched.newPassword ? <IntlMessages id="changePassword.passwordValidationSuccess" /> : ""}
                                            type="password"
                                            name="newPassword"
                                            maxLength="256"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth />

                                    </Grid>

                                    <Grid item xs={12}>

                                        <TextField
                                            label={<IntlMessages id="resetPassword.confirmPassword" />}
                                            value={values.confirmNewPassword}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.confirmNewPassword && touched.confirmNewPassword}
                                            helperText={(errors.confirmNewPassword && touched.confirmNewPassword) ? <IntlMessages id="changePassword.newAndConfirmPasswordDoNotMatch" /> : ""}
                                            type="password"
                                            name="confirmNewPassword"
                                            maxLength="256"
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth />

                                    </Grid>

                                    <Grid item xs={12}>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            fullWidth
                                            disabled={isSubmitting ||
                                                errors.newPassword ||
                                                errors.confirmNewPassword ||
                                                values.newPassword === '' ||
                                                values.confirmNewPassword === '' ||
                                                values.newPassword !== values.confirmNewPassword}>

                                            <IntlMessages id="resetPassword.submit" />

                                        </Button>

                                    </Grid>

                                </Grid>
                                :
                                ''}

                            {values.showError === true
                                ?
                                <Grid container spacing={4}>

                                    <Grid item xs={12}>

                                        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: values.missingCodeMessage } }></Typography>

                                    </Grid>

                                </Grid>
                                :
                                ''}

                        </div>
                    );
                }}
            </FormContainer>
        </StyledPaper>
    );
}

export default ResetPasswordWeb;